import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { BadgeCheckIcon, ExternalLinkIcon, QuoteIcon, StarIcon, ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
const REVIEW_SOURCE_URL = 'https://share.google/iVGpIdNttSw6arPIh';
const REVIEWS = [{
  quote: 'Quick response. Clear communication. Fair pricing. Friendly manner. Would use again!',
  name: 'Darol Klawetter',
  date: '3 weeks ago'
}, {
  quote: "Northface Irrigation's expertise is worth every penny they charge. We are very satisfied with their repair of our sprinkler system.",
  name: 'John Cordova',
  date: '2 months ago'
}, {
  quote: 'Unlike many services I have hired in the past, Raul and his brother arrived on time, even calling to let me know he was on his way. The unit was expertly installed, tested, and made to fit my schedule — not the contractor’s.',
  name: 'Glenn Rhinehart',
  date: '2 months ago'
}];
export function ReviewsSection() {
  const scrollRef = useRef<HTMLDivElement>(null);
  const scroll = (direction: 'left' | 'right') => {
    if (scrollRef.current) {
      const {
        current
      } = scrollRef;
      const scrollAmount = direction === 'left' ? -current.offsetWidth * 0.8 : current.offsetWidth * 0.8;
      current.scrollBy({
        left: scrollAmount,
        behavior: 'smooth'
      });
    }
  };
  return <section id="reviews" className="w-full overflow-hidden bg-slate-50 py-16 sm:py-24" data-id="element-269" data-mp="3gz1xkmdzpxcd">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-270" data-mp="8k00kjzzet58">
        <div className="mx-auto flex max-w-4xl flex-col items-center text-center" data-id="element-271" data-mp="8hnk6b9vgqua">
          <span className="inline-flex items-center gap-2 rounded-full border border-nfblue/15 bg-white px-3.5 py-1.5 text-xs font-bold uppercase tracking-[0.12em] text-nfblue shadow-sm" data-id="element-272" data-mp="dibaeuqa13ng">
            <BadgeCheckIcon className="h-3.5 w-3.5 text-nfgreen-dark" data-id="element-273" data-mp="4gtv3ekp15zt" />
            Customer feedback
          </span>
          <h2 className="mt-5 font-display text-3xl font-extrabold text-slate-900 sm:text-4xl" data-id="element-274" data-mp="2k7znzr6szg05">
            Trusted by North Texas property owners
          </h2>
          <div className="mt-5 flex flex-wrap items-center justify-center gap-x-3 gap-y-2 text-sm" data-id="element-275" data-mp="usf77vnrm7zj">
            <span className="font-display text-2xl font-extrabold text-slate-950" data-id="element-276" data-mp="pssvjqnl4zsu">5.0</span>
            <div className="flex gap-0.5" aria-label="5.0 out of 5 stars" data-id="element-277" data-mp="l1kjsnys92ci">
              {Array.from({
              length: 5
            }).map((_, star) => <StarIcon key={star} className="h-4 w-4 fill-amber-400 text-amber-400" data-id="element-278" data-mp="h0ik660yeoa0" data-mpi={star} />)}
            </div>
            <span className="h-4 w-px bg-slate-300" aria-hidden="true" data-id="element-279" data-mp="bzl1lsc17s7z" />
            <span className="font-semibold text-slate-600" data-id="element-280" data-mp="70zzfnd7yygw">176 Google reviews</span>
          </div>
          <p className="mt-3 max-w-2xl text-base leading-relaxed text-slate-600" data-id="element-281" data-mp="2405gatn9m65">
            Real feedback from customers who trusted Northface with their irrigation
            system, repairs, and property.
          </p>
        </div>

        <div className="mt-12" data-id="element-282" data-mp="1wf6fyt32847j">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.5
        }} className="mb-8 overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm" data-id="element-283" data-mp="1sfnx02usu37c">
            <div className="grid md:grid-cols-2" data-id="element-284" data-mp="3k4ndmn038v6f">
              <div className="relative aspect-video bg-slate-900 md:aspect-auto" data-id="element-285" data-mp="3o4pe4su37ik4">
                <video src="https://cdn.magicpatterns.com/uploads/iBTu5DVowJZimacUfvdKwz/cff95ef3-72e7-4826-ae1b-733ab8791f96.mov" controls playsInline preload="auto" className="absolute inset-0 z-10 h-full w-full object-cover" poster="https://cdn.magicpatterns.com/uploads/hafb5Qu2hSwizsFeVtjDyT/irrigation11.png" data-id="element-286" data-mp="3o6s091s4crjk" />
              </div>
              <div className="flex flex-col justify-center p-8 sm:p-10" data-id="element-287" data-mp="focfaw671goi">
                <div className="flex items-center gap-2" data-id="element-288" data-mp="knfkqhq35ox0">
                  <div className="flex gap-0.5" aria-label="5 out of 5 stars" data-id="element-289" data-mp="kq1rif55k0e6">
                    {Array.from({
                    length: 5
                  }).map((_, star) => <StarIcon key={star} className="h-5 w-5 fill-amber-400 text-amber-400" data-id="element-290" data-mp="e8rs2z1dcp00" data-mpi={star} />)}
                  </div>
                  <span className="rounded-full bg-nfgreen/10 px-2.5 py-0.5 text-xs font-bold text-nfgreen-dark" data-id="element-291" data-mp="s5n675wh96mx">
                    Featured Video Review
                  </span>
                </div>
                <QuoteIcon className="mt-6 h-8 w-8 text-nfblue/20" data-id="element-292" data-mp="123ul7j77hema" />
                <blockquote className="mt-3 text-lg font-medium leading-relaxed text-slate-700" data-id="element-293" data-mp="x61f0q5wkkm0">
                  "Seeing the system run perfectly after the repair is the best proof of their work. They found the issue quickly, fixed it right, and now everything is getting the exact coverage it needs."
                </blockquote>
                <div className="mt-6 flex items-center gap-3 border-t border-slate-100 pt-5" data-id="element-294" data-mp="1kuccrkgay462">
                  <div className="flex h-10 w-10 items-center justify-center rounded-full bg-nfblue/10 text-nfblue" data-id="element-295" data-mp="1fv95dtcunlux">
                    <BadgeCheckIcon className="h-5 w-5" data-id="element-296" data-mp="24i71vb8x3ohr" />
                  </div>
                  <div data-id="element-297" data-mp="24g4devney3f5">
                    <p className="font-bold text-slate-900" data-id="element-298" data-mp="1qipl9j5rzhjh">Jackson Pfeffer</p>
                    <p className="text-xs text-slate-500" data-id="element-299" data-mp="1qks8xwjggyl1">Google review · System Repair</p>
                  </div>
                </div>
              </div>
            </div>
          </motion.div>

          <div className="relative" data-id="element-300" data-mp="1gqjkbjxjpps5">
            <div className="absolute -left-4 top-1/2 z-10 -translate-y-1/2 sm:-left-6" data-id="element-301" data-mp="1ljutvstqsknr">
              <button onClick={() => scroll('left')} className="flex h-12 w-12 items-center justify-center rounded-full border border-slate-200 bg-white text-slate-600 shadow-md transition-colors hover:border-nfblue hover:text-nfblue focus:outline-none focus:ring-2 focus:ring-nfblue focus:ring-offset-2 focus:ring-offset-slate-50" aria-label="Scroll left" data-id="element-302" data-mp="16uqaw9f4icel">
                <ChevronLeftIcon className="h-6 w-6" data-id="element-303" data-mp="34iaiajjh9fpv" />
              </button>
            </div>
            
            <div ref={scrollRef} className="flex snap-x snap-mandatory gap-5 overflow-x-auto pb-8 pt-4 scrollbar-hide" style={{
            scrollbarWidth: 'none',
            msOverflowStyle: 'none'
          }} data-id="element-304" data-mp="2zq9b3c162f6p">
              {REVIEWS.map((review, i) => <motion.figure key={review.name} initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true,
              margin: '-80px'
            }} transition={{
              duration: 0.5,
              delay: i * 0.1
            }} className="relative flex w-[85vw] max-w-[380px] flex-none snap-center flex-col rounded-2xl border border-slate-200 bg-white p-7 shadow-sm sm:w-[400px]" data-id="element-305" data-mp="3ngmuyf9ll7q7" data-mpi={i}>
                <div className="flex items-start justify-between gap-4" data-id="element-306" data-mp="1y1yjcg8tztt8">
                  <div className="flex gap-0.5" aria-label="5 out of 5 stars" data-id="element-307" data-mp="1y41j3rzsd1b5">
                    {Array.from({
                    length: 5
                  }).map((_, star) => <StarIcon key={star} className="h-4 w-4 fill-amber-400 text-amber-400" data-id="element-308" data-mp="ik2a6b8hzns7" data-mpi={star} />)}
                  </div>
                  <div className="flex items-center gap-1.5 text-xs font-bold text-slate-500" data-id="element-309" data-mp="mjsym8ajxrtk">
                    <span className="flex h-5 w-5 items-center justify-center rounded-full bg-white text-xs font-extrabold text-[#4285F4] shadow-sm ring-1 ring-slate-100" data-id="element-310" data-mp="rc473zjcylxq">
                      G
                    </span>
                    Google
                  </div>
                </div>
                <QuoteIcon className="mt-5 h-7 w-7 text-nfblue/20" data-id="element-311" data-mp="169wlgod654ac" />
                <blockquote className="mt-2 flex-1 text-[15px] leading-relaxed text-slate-700" data-id="element-312" data-mp="1aaovhjtv7d7o">
                  “{review.quote}”
                </blockquote>
                <figcaption className="mt-5 flex items-center justify-between gap-3 border-t border-slate-100 pt-4 text-sm" data-id="element-313" data-mp="3821a9qzdflgu">
                  <div data-id="element-314" data-mp="2t5b5nkwijacc">
                    <p className="font-bold text-slate-900" data-id="element-315" data-mp="2t4hxcfhwocs3">{review.name}</p>
                    <p className="mt-0.5 text-xs text-slate-500" data-id="element-316" data-mp="2o6gf1wsb0hho">Google review · {review.date}</p>
                  </div>
                  <BadgeCheckIcon className="h-5 w-5 shrink-0 text-nfgreen" aria-label="Google review" data-id="element-317" data-mp="31xv1kdlf70th" />
                </figcaption>
              </motion.figure>)}
            </div>

            <div className="absolute -right-4 top-1/2 z-10 -translate-y-1/2 sm:-right-6" data-id="element-318" data-mp="2a65rb2majj0q">
              <button onClick={() => scroll('right')} className="flex h-12 w-12 items-center justify-center rounded-full border border-slate-200 bg-white text-slate-600 shadow-md transition-colors hover:border-nfblue hover:text-nfblue focus:outline-none focus:ring-2 focus:ring-nfblue focus:ring-offset-2 focus:ring-offset-slate-50" aria-label="Scroll right" data-id="element-319" data-mp="257m0oowr5j21">
                <ChevronRightIcon className="h-6 w-6" data-id="element-320" data-mp="3pnz0w8rkseeo" />
              </button>
            </div>
          </div>

        </div>

        <div className="mt-4 flex justify-center" data-id="element-321" data-mp="1x8xrc3bjwlv">
          <a href={REVIEW_SOURCE_URL} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 rounded-full border border-slate-300 bg-white px-5 py-3 text-sm font-bold text-slate-800 shadow-sm transition-colors hover:border-nfblue hover:text-nfblue focus:outline-none focus:ring-2 focus:ring-nfblue focus:ring-offset-2" data-id="element-322" data-mp="605mzlnd6qys">
            View all Google reviews
            <ExternalLinkIcon className="h-4 w-4" data-id="element-323" data-mp="krnyb65a3xbt" />
          </a>
        </div>
        <p className="mt-3 text-center text-xs text-slate-500" data-id="element-324" data-mp="pnlencgjl3ol">
          Read and verify every review directly on Northface Irrigation's Google Business Profile.
        </p>
      </div>
    </section>;
}